import React from 'react';

export default function HubTabs({ tabs, active, onChange, className = '', ariaLabel }) {
  return (
    <div className={`vi-tabs-wrap ${className}`.trim()} dir="rtl">
      <div className="vi-tabs" role="tablist" aria-label={ariaLabel}>
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={active === t.id}
            className={active === t.id ? 'vi-tab vi-tab--active' : 'vi-tab'}
            onClick={() => onChange(t.id)}
          >
            {t.icon && <span className="vi-tab__icon" aria-hidden>{t.icon}</span>}
            <span className="vi-tab__label">{t.label}</span>
            {t.badge != null && t.badge !== '' && (
              <span className="vi-tab__badge">{t.badge}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}